import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';

export abstract class RepeaterModelFieldPaths
{
    public static readonly VALUES_FIELD:FieldPath = 'values';
    public static readonly COUNT_FIELD:FieldPath = 'count';
    public static readonly DISPLAY_TYPE_FIELD:FieldPath = 'displayType';
    public static readonly OFFSET_X_FIELD:FieldPath = 'offsetX.unitsString';
    public static readonly OFFSET_Y_FIELD:FieldPath = 'offsetY.unitsString';
    public static readonly NUMBER_OF_COLUMNS_FIELD:FieldPath = 'numberOfColumns';
    public static readonly OFFSET_FIELD:FieldPath = 'offset';
    public static readonly LIMIT_FIELD:FieldPath = 'limit';
}
